// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Root":"Input_Root__2Lx_n","RootIsRequired":"Input_RootIsRequired__3UZ8R"};